import type { FC } from "react";
import {
  CoreCarsComponent,
  useCarsStyles,
  type CarReservationDetailTitleProps,
  CarReservationStatusPill,
} from "@apac/components/cars";
import { useModuleBEM } from "@b2bportal/core-themes";
import { Trans, useI18nContext } from "@hopper-b2b/i18n";
import defaultStyles from "./CarReservationDetailTitle.module.scss";
import { useCarTripStatus } from "@/modules/cars-postbooking/hooks";
import { getCarConfirmationCode } from "@/utilities/cars";

export const CarReservationDetailTitle: FC<CarReservationDetailTitleProps> = ({
  reservation,
}) => {
  const styles = useCarsStyles(
    CoreCarsComponent.CarReservationDetailTitle,
    defaultStyles
  );
  const { t } = useI18nContext();
  const [block, cn] = useModuleBEM(
    styles,
    CoreCarsComponent.CarReservationDetailTitle
  );

  const { isPast } = useCarTripStatus(reservation);

  return (
    <div className={block}>
      <CarReservationStatusPill
        state={reservation.state}
        isPastTrip={isPast}
        className={cn("tag")}
      />
      <h1 className={cn("title")}>
        {t("trips.cars.carRentals", { city: reservation.pickUp.location.city })}
      </h1>
      <p className={cn("confirmation-code-container")}>
        <Trans
          i18nKey="trips.confirmationCodeLabelAndCode"
          values={{
            code: getCarConfirmationCode(reservation) ?? "",
          }}
          components={{
            b: <span className={cn("confirmation-code")} />,
          }}
        />
      </p>
    </div>
  );
};
